"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * The props for the Label component.
 */

const Label = _ref => {
  let {
    children,
    className,
    forId,
    required,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("label", _extends({
    className: (0, _classnames.default)(className, "p-form__label", {
      "is-required": required
    }),
    htmlFor: forId
  }, props), children);
};
var _default = exports.default = Label;